import { Bell, User, RefreshCw } from "lucide-react"
import { useRealTimeData } from "../hooks/useRealTimeData"

const Header = () => {
  const { lastUpdate, isLoading } = useRealTimeData()

  return (
    <header className="header">
      <div>
        <h2 className="text-2xl font-bold text-gray-900">Explosive Detection Dashboard</h2>
        <p className="text-sm text-gray-600">Real-time monitoring of IoT security devices</p>
      </div>

      <div className="flex items-center space-x-6">
        <div className="flex items-center text-sm text-gray-600">
          <RefreshCw className={`h-4 w-4 mr-2 ${isLoading ? "animate-spin text-blue-500" : "text-gray-400"}`} />
          <span>Last update: {lastUpdate ? new Date(lastUpdate).toLocaleTimeString() : "Never"}</span>
        </div>

        <button className="relative p-2 text-gray-600 hover:text-gray-900">
          <Bell className="h-5 w-5" />
          <span className="absolute top-0 right-0 h-2 w-2 bg-red-500 rounded-full"></span>
        </button>

        <div className="flex items-center space-x-3">
          <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center">
            <User className="h-5 w-5 text-white" />
          </div>
          <div>
            <span className="text-sm font-medium text-gray-700">Admin User</span>
            <p className="text-xs text-gray-500">Security Officer</p>
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header


